/***
*
*   BILLING
*   Change subscription, update card details or view past invoices
*
**********/

import React, { Fragment, useContext } from 'react';
import { AuthContext, TabView, Message, Animate, useAPI } from 'components/lib';

import { BillingPlan } from './plan';
import { BillingCard } from './card';
import { BillingInvoices } from './invoices';
import FirmNav from '../nav';
import { SignupPlan } from './signupPlan';

const Messages = require('./messages.json');

export function Billing(props){

  // state/context
  const context = useContext(AuthContext);

  // fetch subscription
  const subscription = useAPI('/api/billing/subscription');
  const isPaid = context.user.plan === 'free' ? false : true;
  const labels = ['Plan']; if (isPaid) labels.push('Card', 'Invoices');


  return (
    <Fragment>

      <Animate>
        <FirmNav />
        { !subscription?.loading && 
          (subscription?.data?.status !== 'active' && subscription?.data?.status !== 'trialing') &&
          <Message { ...Messages[subscription.data?.status] } />
        }

        {/* <Message
          title={"Data Connections"}
          text={"Total Connections: " + (connections?.data?.length || 0)}
          type={'success'}
        /> */}

{ context.user.plan === 'free' ?
            <SignupPlan />
            :
            <>
        <TabView name='Billing' labels={ labels }>
            <BillingPlan subscription={ subscription } />

          { isPaid && 
          <BillingCard /> }

          { isPaid && 
          <BillingInvoices /> }

        </TabView>
        </>
        }
      </Animate>

    </Fragment>
  );
}
